// @ts-nocheck
/* eslint-disable */

import axios, { AxiosRequestConfig } from 'axios'
import { BlackListError } from './components/cart/cartInterfaces';

declare var moment: any;
declare var document: any;
declare var window: any;

export function initEvent(name: string) {
  let e = document.createEvent('CustomEvent');
  e.initCustomEvent(name, true, true, null);

  return e;
}

export function getEnv() : string {
  return JSON.parse(sessionStorage.getItem('shopInfos')).env;
}

let controllerEmail = null;
export function emailIsValid(email: string) : any {
  if(controllerEmail) {
    controllerEmail.abort();
  } 
  controllerEmail = new AbortController();
  return axios.post(getHostApi() + '/customers/emails/validate', {
    email: email
  }, {signal:controllerEmail.signal, ...getRequestConfig()}).then((res) => {
    return res.data.valid;
  }).catch((res) => {
    return null;
  });
}

export function supportPolymer() : boolean {
  return 'content' in document.createElement('template') && 'import' in document.createElement('link')
    && 'registerElement' in document && document.head.createShadowRoot;
}

export function isServerSide() : boolean {
  return (typeof window === 'undefined');
}

export function getHostApi() : string {
  return window.hostApi || '/order/api';
}

export function getShopInfo() : any {
  return JSON.parse(sessionStorage.getItem('shopInfos'));
}

export async function request(method: string, url: string, config: any) {
  let result = null;

  try {
    result = await axios.request({
      method: method,
      url: url,
      ...config,
    });
  } catch (err) {
    const msg = (err.response && err.response.data) ? err.response.data : err.message;

    console.error(method, url, msg, config);

    throw err;
  }

  return result;
}

/**
 * Genrère les entetes essentiels pour les requetes vers l'api
 * @param fromToken
 */
export function getRequestConfig(fromToken: string = null): AxiosRequestConfig {
  return (isServerSide()) ? {
    timeout: 5000,
  } : {
    headers: {
      'x-xsrf-token': localStorage.getItem('xsrfToken') || 0
    },
    withCredentials: true
  };
}

/**
 * Genrère les entetes essentiels pour les requetes vers l'api
 */
export function getRequestConfigForFetch(signal?: AbortSignal): RequestInit {
  const controller = new AbortController();
  if (isServerSide()) {
    setTimeout(() => controller.abort(), 5000);
  }
  signal?.addEventListener('abort', () => controller.abort());
  return {
    credentials: 'include',
    headers: {
      'x-xsrf-token': localStorage.getItem('xsrfToken') || 0
    },
    signal: controller.signal
  };
}

export function textTruncate(str: string, lengthString: number = 100, ending: string = '...') {
  if (str.length > lengthString) {
    return str.substring(0, lengthString - ending.length) + ending;
  }
  return str;
}

/**
 * Permet de remplacer toute les occurences du chaine par une autre
 */
export function replaceAll(str: string, search: string, replacement: string) {
  return str.replace(new RegExp(search, 'g'), replacement);
}

/**
 * Permet de formater une date
 */
export function dateFormat(lang: string, fromDate:string, format:string) {
  let isDate = moment(fromDate).toDate();
  let dateFormat = moment(isDate).locale(lang).format(format);
  return dateFormat;
}

export function encode(text: string) {
  return unescape(encodeURIComponent(text));
}

export const checkStock = (cartId: string) => {
  if(!cartId) {
    return Promise.resolve({valid: true});
  }
  
  return axios.get(`${getHostApi()}/carts/${cartId}/check-stock`, getRequestConfig())
      .then((res) => {
        return new Promise((resolve, reject) => {
          if(res.data?.valid) {
            resolve(res.data);
          } else {
            reject(res.data);
          }
        });
      });
}

export async function checkBlacklist(cartId: string, isoCode: string): Promise<BlackListError> {
  const response = await axios.get(
    `${getHostApi()}/carts/${cartId}/check-blacklist?isoCode=${isoCode}`,
    getRequestConfig()
  );
  return response.data;
}

export const scrollTo = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

export const TRANSFER_SURFACE_EMPLACEMENT_ID = 4946;

export function getCountryDeliveryCode(): string {
  const countryDelivery = localStorage.getItem('countryDelivery');
  let countryCode = 'FR';
  if (countryDelivery) {
    countryCode = countryDelivery;
  }
  return countryCode;
}

export function getInfosI18n(): { id: number, locale: string } {
  const i18nLangStr = localStorage.getItem('i18nLang');
  let idLang = 1;
  let locale = 'fr';
  if (i18nLangStr) {
    const i18nLangObj = JSON.parse(i18nLangStr);
    idLang = i18nLangObj.id;
    locale = i18nLangObj.lang;
  }
  return { id: idLang, locale };
}

export function formatDateWithLocale(date: Date, includeTime: boolean = false): string {
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    ...(includeTime ? { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' } : {}),
  };

  return new Intl.DateTimeFormat(getInfosI18n().locale.toLowerCase(), options).format(date);
}

export function formatNumericDateWithLocale(date: Date, includeTime: boolean = false): string {
  const options: Intl.DateTimeFormatOptions = includeTime
    ? { dateStyle: 'short', timeStyle: 'short' }
    : { dateStyle: 'short' };

  return new Intl.DateTimeFormat(getInfosI18n().locale.toLowerCase(), options).format(date);
}

export function formatPriceWithCurrency(price: number, currency: string = 'EUR'): string {
  const { locale } = getInfosI18n();
  const hasDecimals = Math.round(price * 100) % 100 !== 0;
  return price.toLocaleString(locale, {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol',
  });
}
